import React, { useEffect, useState } from 'react'
import Compressor from 'compressorjs';
import AWS from "aws-sdk";
import useImageConfigS3 from '../HelperComponent/useImageConfigS3';

const useFileHandleS3 = (file=null,upKey=null,delKey=null) => {

    const [s3,bucketName] = useImageConfigS3([]);
    const [progress, setProgress] = useState(0);
    const [fileUrl, setFileUrl] = useState('');
    const [fileKey, setFileKey] = useState('');

    const [uploadFile, setFile] = useState(null);
    const [deleleFileKey, setDeleteFile] = useState(null);


    useEffect(() => {
      setFile(file);
      setDeleteFile(delKey);
      setProgress(0);
    }, [file,delKey]);


      const handleDelete = (delFile) => {

          const params = {
      
              Bucket: bucketName,
              Key: delFile,
            };
          s3.deleteObject(params, (err, data) => {
              if (err) {
                console.error(err);
                return;
              }
              console.log(data);
            });
        
      }
      if(deleleFileKey){
          handleDelete(deleleFileKey);
          setDeleteFile(null);
          setFileUrl(null);
      }

    const handleUpload = (file) => {
        const extension = file.name.split(".").pop();
        const fileName = new Date().getTime()+"."+extension;

        new Compressor(file,{
          quality:0.6,
          maxWidth:900,
          maxHeight:454,
          success(result){
            const params = {
 
              Bucket: process.env.REACT_APP_S3_BUCKET,
              Key: upKey +"/"+fileName,
              Body: result,
            };
      
            s3.upload(params, (err, data) => {
              if (err) {
                console.error(err);
                return;
              }
              setFileUrl(data.Location);
              setFileKey(data.Key);
            })
            .on("httpUploadProgress", (evt) => {
              const progressPercentage = parseInt(
                (evt.loaded * 100) / evt.total
              );
              setProgress(progressPercentage);
            });
          }

        })


    };

    if(uploadFile){
        handleUpload(uploadFile);
        setFile(null);
    }

    return [fileUrl,fileKey,progress];
}

export default useFileHandleS3